import { PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/portal';
import { EscrowPaymentHistoryItemId } from '@willow/types-iso';

import { TPaymentFormShape } from './form';

export type PaymentModalType = 'overPayment' | 'underPayment' | 'confirmPayment' | 'dwollaLimit';

export const getPaymentFormActiveModalType = ({
  paymentIntention,
  paymentAmount,
  escrowShortageAnalysisId,
  activeWorkoutPlan,
  totalAmountDue,
  totalAmountDueToReinstateLoan,
  minAmountDue,
}: {
  paymentIntention: TPaymentFormShape['paymentIntention'];
  paymentAmount: number;
  escrowShortageAnalysisId: EscrowPaymentHistoryItemId | undefined;
  activeWorkoutPlan: PortalWorkoutPlanFragment | undefined;
  totalAmountDue: number;
  totalAmountDueToReinstateLoan: number;
  minAmountDue: number;
}): PaymentModalType => {
  // Check if under or over payment
  if (paymentIntention === 'totalWithShortage' && escrowShortageAnalysisId) {
    return 'confirmPayment';
  }
  if (activeWorkoutPlan) {
    /* 
      1. Pay down the workout payment plan amount due
      2. Additional payments after the workout plan should be applied based on the actual amount due on the loan. So, don't bring up the overpayment modal if paying beyond the workout plan, but under the reinstatement amount
    */
    if (paymentAmount > totalAmountDueToReinstateLoan) {
      // Only show the overpayment modal if paying off the workout plan. All payments should be allocated as normal to the late payments
      return 'overPayment';
    }
    if (paymentAmount < totalAmountDue) {
      // Underpayment for the workout plan
      return 'underPayment';
    }
    // We are either paying the exact amount due on the workout plan OR paying beyond the workout plan, but under the reinstatement amount
    return 'confirmPayment';
  }
  if (minAmountDue > 0 && minAmountDue > paymentAmount) {
    // Underpayment
    return 'underPayment';
  }
  if (totalAmountDue < paymentAmount) {
    // Overpayment
    return 'overPayment';
  }
  // Exact amount being submitted
  return 'confirmPayment';
};
